"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSelectedPart = void 0;
const selectors_1 = require("../selectors");
const useSelector_1 = require("./useSelector");
const EMPTY_VALUE = {};
function useSelectedPart() {
    var _a;
    return (_a = (0, useSelector_1.useSelector)(selectors_1.getSelectedPart)) !== null && _a !== void 0 ? _a : EMPTY_VALUE;
}
exports.useSelectedPart = useSelectedPart;
